import React from "react";
import styled, { keyframes } from "styled-components";
import Menu from "./Menu";
import DesktopMenu from "./DesktopMenu";

const Home = () => {
  return (
    <Page>
      <DesktopMenu />

      <HeroWrap>
        <HeroCard className="surface">
          <Sigil aria-hidden="true">
            <svg viewBox="0 0 600 600">
              <defs>
                <radialGradient id="halo" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="rgba(255,119,200,0.18)" />
                  <stop offset="55%" stopColor="rgba(43,189,95,0.08)" />
                  <stop offset="100%" stopColor="rgba(31,27,22,0.00)" />
                </radialGradient>

                <linearGradient id="stroke" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="rgba(31,27,22,0.60)" />
                  <stop offset="50%" stopColor="rgba(31,27,22,0.28)" />
                  <stop offset="100%" stopColor="rgba(31,27,22,0.55)" />
                </linearGradient>
              </defs>

              {/* soft halo */}
              <circle cx="300" cy="300" r="260" fill="url(#halo)" />

              {/* rotating dashed ring */}
              <circle
                className="spin"
                cx="300"
                cy="300"
                r="190"
                fill="none"
                stroke="url(#stroke)"
                strokeWidth="2"
                strokeDasharray="6 10"
                opacity="0.85"
              />

              {/* inner ring */}
              <circle
                cx="300"
                cy="300"
                r="120"
                fill="none"
                stroke="rgba(31,27,22,0.45)"
                strokeWidth="2"
                opacity="0.7"
              />

              {/* nodes */}
              <g opacity="0.95">
                <circle cx="300" cy="105" r="6" fill="rgba(43,189,95,0.85)" />
                <circle cx="485" cy="300" r="6" fill="rgba(255,119,200,0.85)" />
                <circle cx="300" cy="495" r="6" fill="rgba(226,58,46,0.75)" />
                <circle cx="115" cy="300" r="6" fill="rgba(43,189,95,0.75)" />
              </g>

              {/* crosshair */}
              <g opacity="0.28" stroke="rgba(31,27,22,0.55)" strokeWidth="1">
                <line x1="300" y1="78" x2="300" y2="522" />
                <line x1="78" y1="300" x2="522" y2="300" />
              </g>
            </svg>
          </Sigil>

          <Brand>
            <Title>Spectral Center</Title>
    

                   <Lede>
        Spectral Center is an organization for collective consciousness research through art, sound, and hypnosis. 
            </Lede>

            <AccentRow aria-hidden="true">
              <Dot $c="var(--brand-green)" />
              <Dot $c="var(--brand-pink)" />
              <Dot $c="var(--brand-red)" />
            </AccentRow>
          </Brand>
        </HeroCard>
      </HeroWrap>

      <Menu />
    </Page>
  );
};

const Page = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  @media (min-width: 1000px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

const HeroWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  transform: translateY(-6vh);

  @media (min-width: 1000px) {
    width: 55%;
    padding: 24px;
    transform: translateY(-4vh);
  }
`;


const floaty = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0px); }
`;

const slowSpin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const HeroCard = styled.div`
  width: min(820px, 100%);
  border-radius: 0;
  border: none;
  background: transparent;
  box-shadow: none;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;

  @media (min-width: 760px) {
    padding: 12px 0;
    gap: 8px;
  }
`;


const Sigil = styled.div`
  width: 100%;
  display: grid;
  place-items: center;
  animation: ${floaty} 6.5s ease-in-out infinite;

  svg {
    width: min(520px, 92%);
    height: auto;
  }

  .spin {
    transform-origin: 300px 300px;
    animation: ${slowSpin} 24s linear infinite;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
`;

const Title = styled.h1`
  font-family: var(--font-heading), sans-serif;
  font-weight: 800;
  font-size: 1.7rem;
  line-height: 1.1;
  margin: 0;
`;

const Micro = styled.div`
  font-family: var(--font-body);
  font-size: 0.95rem;
  color: var(--muted);
`;

const Lede = styled.p`
  font-family: var(--serif, inherit);
  font-size: 1rem;
  line-height: 1.6;
  max-width: 42ch;
  color: var(--ink-soft, currentColor);
  margin: 0.75rem 0 0;
`;

const AccentRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 2px;
`;

const Dot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 99px;
  background: ${({ $c }) => $c};
  opacity: 0.9;
`;

export default Home;
